const requests = {
  getTopAiringAnimes: `/top/anime/1/airing`,
  getTopUpcomingAnimes: `/top/anime/1/upcoming`,
  getTopTvAnimes: `/top/anime/1/tv`,
  getTopMovieAnimes: `/top/anime/1/movie`,
  getTopOvaAnimes: `/top/anime/1/ova`,
  getTopSpecialAnimes: `/top/anime/1/special`,
  getTopMangas: `/top/manga/1/manga`,
  getTopNovels: `/top/manga/1/novels`,
}

export default requests
